export function getActionFieldErrorKey(path: string[]) {
    return path.join(' ')
}
